import { render, staticRenderFns } from "./SaveCancelMessage.vue?vue&type=template&id=1f0d36eb&"
import script from "./SaveCancelMessage.vue?vue&type=script&lang=js&"
export * from "./SaveCancelMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports